// /src/components/imovel/cadastro/2EtapaLocalizacao.jsx
// VERSÃO 11.0 SUPREMA - HERANÇA DE CSS PAI & MULTI-ZONA (TIM UNITY)

import React, { useState } from 'react';
import { SelectField } from './FormControls';
import axios from 'axios';
import { 
    FiMapPin, FiNavigation, FiSearch, FiLayers, 
    FiMap, FiGlobe, FiShield, FiActivity, FiTarget, FiPlus, FiX, FiCheck 
} from 'react-icons/fi';

const LISTA_UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

export default function EtapaLocalizacao({ formData, handleChange }) {
    const [cepInput, setCepInput] = useState('');
    const [cepLoading, setCepLoading] = useState(false);
    const nivelAtual = formData.nivelCobertura || 'Brasil';

    // ⚔️ FUNÇÃO: ALTERNAR ESTADO (ARRAY MULTI-UF)
    const toggleEstado = (uf) => {
        const atuais = formData.estadosCobertura || [];
        const novos = atuais.includes(uf) 
            ? atuais.filter(item => item !== uf) 
            : [...atuais, uf];
        handleChange({ target: { name: 'estadosCobertura', value: novos } });
    };

    // 🛰️ RADAR DE BUSCA: CEP CIRÚRGICO (ADD NA LISTA)
    const addLocationByCep = async () => {
        const cleanCep = cepInput.replace(/\D/g, '');
        if (cleanCep.length !== 8) return;
        setCepLoading(true);

        try {
            const res = await axios.get(`https://viacep.com.br/ws/${cleanCep}/json/`);
            if (!res.data.erro) {
                const novaLoc = {
                    cep: res.data.cep,
                    rua: res.data.logradouro,
                    bairro: res.data.bairro,
                    cidade: res.data.localidade,
                    estado: res.data.uf,
                    id: `loc-${Date.now()}`
                };
                const atuais = formData.locaisCirurgicos || [];
                handleChange({ target: { name: 'locaisCirurgicos', value: [...atuais, novaLoc] } });
                setCepInput('');
            }
        } catch (err) {
            console.error("💥 Falha no Radar de Geolocalização.");
        } finally {
            setCepLoading(false);
        }
    };

    const removeLocation = (id) => {
        const novos = (formData.locaisCirurgicos || []).filter(l => l.id !== id);
        handleChange({ target: { name: 'locaisCirurgicos', value: novos } });
    };

    return (
        <div className="w-full space-y-10 animate-in fade-in zoom-in-95 duration-700 pb-20">
            
            {/* 🛡️ CABEÇALHO (Herda var(--bg-main) e var(--text-primary)) */}
            <div className="flex items-center gap-6 mb-12 border-b border-[var(--border-color)] pb-8">
                <div className="relative">
                    <div className="w-16 h-16 rounded-3xl bg-[var(--accent-color)]/10 border border-[var(--accent-color)]/20 flex items-center justify-center text-[var(--accent-color)] shadow-2xl">
                        <FiGlobe size={32} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-7 h-7 bg-[var(--accent-color)] text-white rounded-full flex items-center justify-center font-black text-[12px] shadow-lg">02</div>
                </div>
                <div>
                    <h2 className="text-3xl font-black uppercase tracking-tighter leading-none" style={{ color: 'var(--text-primary)' }}>
                        Abrangência da <span className="text-[var(--accent-color)]">Oferta</span>
                    </h2>
                    <p className="text-[10px] font-black uppercase tracking-[0.4em] opacity-40 mt-2" style={{ color: 'var(--text-primary)' }}>
                        Mapeamento Multi-Zona de Validade do Plano
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                
                {/* 🎯 SELETOR DE NÍVEL (Herda var(--bg-card)) */}
                <div className="col-span-12 p-8 rounded-[2.5rem] border border-[var(--border-color)] bg-[var(--bg-card)] shadow-inner">
                    <Label icon={FiTarget} text="Definição de Alcance Tático" />
                    <SelectField 
                        name="nivelCobertura" 
                        value={nivelAtual} 
                        onChange={handleChange} 
                        options={[
                            { value: 'Brasil', label: 'Nível Brasil (Nacional)' },
                            { value: 'Estados', label: 'Nível Estadual (Múltiplos Estados)' },
                            { value: 'Cidades', label: 'Nível Cirúrgico (Múltiplos Endereços)' }
                        ]} 
                    />
                    <p className="text-[10px] font-bold mt-4 uppercase tracking-widest opacity-60" style={{ color: 'var(--accent-color)' }}>
                        {nivelAtual === 'Brasil' && ">> Oferta ativada para todo o território nacional."}
                        {nivelAtual === 'Estados' && ">> Selecione abaixo todas as UFs onde o plano é válido."}
                        {nivelAtual === 'Cidades' && ">> Injete CEPs específicos para cobertura cirúrgica."}
                    </p>
                </div>

                {/* 🗺️ ZONA ESTADUAL (MULTI-UF) */}
                {nivelAtual === 'Estados' && (
                    <div className="col-span-12 space-y-6 animate-in slide-in-from-top-4 duration-500">
                        <Label icon={FiMap} text="Arsenal Regional (Selecione os Estados)" />
                        <div className="grid grid-cols-4 md:grid-cols-9 gap-2">
                            {LISTA_UFS.map(uf => {
                                const isSelected = formData.estadosCobertura?.includes(uf);
                                return (
                                    <button
                                        key={uf}
                                        type="button"
                                        onClick={() => toggleEstado(uf)}
                                        className={`h-12 rounded-xl border font-black text-[11px] transition-all flex items-center justify-center gap-1 ${
                                            isSelected 
                                            ? 'bg-[var(--accent-color)] border-[var(--accent-color)] text-white scale-105 shadow-lg' 
                                            : 'bg-[var(--bg-card)] border-[var(--border-color)] opacity-40 hover:opacity-100'
                                        }`}
                                        style={{ color: isSelected ? '#fff' : 'var(--text-primary)' }}
                                    >
                                        {isSelected && <FiCheck size={12} />} {uf}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* 📍 ZONA CIRÚRGICA (MULTI-CEP) */}
                {nivelAtual === 'Cidades' && (
                    <div className="col-span-12 space-y-8 animate-in slide-in-from-top-4 duration-500">
                        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
                            <div className="md:col-span-5 lg:col-span-4">
                                <Label icon={FiSearch} text="Injetar CEP no Radar" />
                                <div className="flex gap-2">
                                    <input 
                                        type="text"
                                        value={cepInput}
                                        onChange={(e) => setCepInput(e.target.value)}
                                        placeholder="00000-000"
                                        className="flex-1 h-[60px] outline-none"
                                        style={{ backgroundColor: 'var(--bg-card)', color: 'var(--text-primary)', borderColor: 'var(--border-color)' }}
                                    />
                                    <button 
                                        type="button"
                                        onClick={addLocationByCep}
                                        disabled={cepLoading}
                                        className="w-[60px] h-[60px] rounded-2xl flex items-center justify-center text-white transition-all active:scale-95"
                                        style={{ backgroundColor: 'var(--accent-color)' }}
                                    >
                                        {cepLoading ? <FiActivity className="animate-spin" /> : <FiPlus size={24} />}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* LISTA DE LOCAIS (Cards Dinâmicos) */}
                        <div className="space-y-4">
                            <Label icon={FiLayers} text="Pontos de Cobertura Ativos" />
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {(formData.locaisCirurgicos || []).map((loc) => (
                                    <div key={loc.id} 
                                         className="p-5 rounded-[2rem] border flex justify-between items-center group hover:border-[var(--accent-color)] transition-all"
                                         style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border-color)' }}>
                                        <div className="flex items-center gap-4">
                                            <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-[var(--accent-color)]" style={{ backgroundColor: 'var(--bg-main)' }}>
                                                <FiMapPin size={20} />
                                            </div>
                                            <div>
                                                <h4 className="text-[11px] font-black uppercase" style={{ color: 'var(--text-primary)' }}>{loc.cidade} - {loc.estado}</h4>
                                                <p className="text-[9px] font-bold uppercase opacity-40" style={{ color: 'var(--text-primary)' }}>{loc.rua} | {loc.cep}</p>
                                            </div>
                                        </div>
                                        <button 
                                            type="button"
                                            onClick={() => removeLocation(loc.id)}
                                            className="p-2 opacity-20 hover:opacity-100 hover:text-red-500 transition-all"
                                            style={{ color: 'var(--text-primary)' }}
                                        >
                                            <FiX size={20} />
                                        </button>
                                    </div>
                                ))}
                                {(!formData.locaisCirurgicos || formData.locaisCirurgicos.length === 0) && (
                                    <div className="col-span-full p-12 border border-dashed rounded-[3rem] text-center opacity-20" style={{ borderColor: 'var(--border-color)' }}>
                                        <p className="text-[10px] font-black uppercase tracking-[0.3em]" style={{ color: 'var(--text-primary)' }}>Nenhum Ponto Cirúrgico Mapeado</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* 🛡️ STATUS DO RADAR */}
                <div className="col-span-12 mt-10">
                    <div className="p-8 rounded-[3rem] border border-dashed bg-[var(--bg-card)]/50 flex flex-col items-center justify-center text-center space-y-3" style={{ borderColor: 'var(--border-color)' }}>
                        <FiShield size={28} className="text-[var(--accent-color)] opacity-30" />
                        <span className="text-[10px] font-black uppercase tracking-[0.4em] opacity-40" style={{ color: 'var(--text-primary)' }}>
                            {nivelAtual === 'Brasil' && "Radar Nacional Homologado"}
                            {nivelAtual === 'Estados' && `Radar Regional: ${formData.estadosCobertura?.length || 0} UFs Ativas`}
                            {nivelAtual === 'Cidades' && `Radar Cirúrgico: ${formData.locaisCirurgicos?.length || 0} Pontos Injetados`}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

// 💎 SUB-COMPONENTE: LABEL DNA
const Label = ({ icon: Icon, text }) => (
    <div className="flex items-center gap-3 mb-4">
        <Icon size={16} className="text-[var(--accent-color)]" />
        <label className="text-[11px] font-black uppercase tracking-[0.2em] opacity-60" style={{ color: 'var(--text-primary)' }}>
            {text}
        </label>
    </div>
);